import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiFormHelperService } from './fi-form-helper.service';
import { FiFormSharedService } from './fi-form-shared.service';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiValidatingFormModule } from '../fi-directives/fi-validating-form/fi-validating-form.module';
import { FiAppTextSharedModule } from '../app-text';
import { FiFormViewerQuestionComponent } from './fi-form-viewer/fi-form-viewer-question/fi-form-viewer-question.component';
import { FiFormViewerComponent } from './fi-form-viewer/fi-form-viewer.component';
import { FiLoadingModule } from '../fi-loading/fi-loading.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiMediaViewerModule } from '../media-viewer/media-viewer.module';
import { FiContentLanguageSharedModule } from '../fi-content-language-shared/fi-content-language-shared.module';
import { FiAttachmentsModule } from '../media-bank/fi-attachments/fi-attachments.module';
import { FiFormConditionHelperService } from '@fi-shared/fi-form-shared/fi-form-condition-helper.service';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiFormViewerBusinessUnitSelectComponent } from './fi-form-viewer/fi-form-viewer-business-unit-select/fi-form-viewer-business-unit-select.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiNumberOnlyModule } from '@fi-shared/fi-directives/number-only/number-only.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatButtonModule,
        MatSelectModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        FiAppTextSharedModule,
        FiValidatingFormModule,
        FiErrorMessageModule,
        MatRadioModule,
        MatInputModule,
        MatListModule,
        FiContentLanguageSharedModule,
        FiLoadingModule,
        FiMediaViewerModule,
        FiAttachmentsModule,
        FiBindHtmlCompileModule,
        SelectSearchModule,
        MatCheckboxModule,
        FiNumberOnlyModule,
    ],
    declarations: [FiFormViewerComponent, FiFormViewerQuestionComponent, FiFormViewerBusinessUnitSelectComponent],
    providers: [FiFormSharedService, FiFormHelperService, FiFormConditionHelperService],
    exports: [FiFormViewerComponent, FiFormViewerQuestionComponent],
})
export class FiFormSharedModule {}
